import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_TORNEOS = 'ALL_TORNEOS';
export const ACTIVO_TORNEOS = 'ACTIVO_TORNEOS';
export const LOADING_ALL_TORNEOS = 'LOADING_ALL_TORNEOS';
export const PARAMS_TORNEOS = 'PARAMS_TORNEOS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const torneosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_TORNEOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_TORNEOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_TORNEOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_TORNEOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
